import axios from 'axios';
import querystring from 'querystring';

const statuses = {
    403: 'Запрещено',
    413: 'Request Entity Too Large'
};

export default function apiFetch(config) {
    let method = (config.method || 'POST').toUpperCase();
    let url = config.url;

    if (!url) return Promise.reject('Не указан url запроса');

    let params = config.params || {};
    if (method !== 'GET') {
        params =
            params instanceof FormData ? params : querystring.stringify(params);
    }

    return new Promise((resolve, reject) => {
        axios({
            method,
            url,
            data: params
        })
            .then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                    return;
                }
                if (response.status === 401) {
                    window.showAuthPopup();
                    return;
                }
                throw new Error(response.status);
            })
            .catch(error => {
                let message = statuses[error.message] || 'Что-то пошло не так';
                reject(message);
            });
    });
}
